import { RouterProvider } from 'react-router-dom';

// project imports
import router from './routes';
import ThemeCustomization from './themes';

import RTLLayout from './components/RTLLayout';
import ScrollTop from './components/ScrollTop';
import Snackbar from './components/@extended/Snackbar';
import Notistack from './components/third-party/Notistack';
import { UserProvider } from './contexts/UserContext';
import { FilterProvider } from './contexts/FilterContext';
import { CookiesProvider } from "react-cookie";
import ContactModal from './components/ContactModal';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <>
      <CookiesProvider>
        <ThemeCustomization>
          <RTLLayout>
              <ScrollTop>
                <UserProvider>
                  <FilterProvider>
                    <Notistack>
                      <RouterProvider router={router} />
                      <Snackbar />
                    </Notistack>
                  </FilterProvider>
                </UserProvider>
              </ScrollTop>
          </RTLLayout>
        </ThemeCustomization>
      </CookiesProvider>
    </>
  );
}
